import { Col, Container, Row } from "reactstrap"
import HeaderOrange from "../../../../components/common/HeaderOrange/HeaderOrange"
import Testimonials from "../../../../assets/images/SellerPortalImages/Services/testimonials.png"
import TermsAndPolicies from "../../../../assets/images/SellerPortalImages/Services/terms-and-policies.png"
import TrainingAndResources from "../../../../assets/images/SellerPortalImages/Services/training-and-resources.png"
import CustomerServices from "../../../../assets/images/SellerPortalImages/Services/customer-services.png"
import ContactAndSupport from "../../../../assets/images/SellerPortalImages/Services/contact-and-support.png"
import Card from "./Card/Card"

const Services = () => {
  const cardData = [
    { imageSrc: Testimonials, label: "Testimonials" },
    { imageSrc: TermsAndPolicies, label: "Terms and Policies" },
    { imageSrc: TrainingAndResources, label: "Training and Resources" },
    { imageSrc: CustomerServices, label: "Customer Services" },
    { imageSrc: ContactAndSupport, label: "Contact and Support" },
  ]

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", paddingBlock: "1rem" }}>
      <Container fluid>
        <div className="fw-semibold fs-4 mb-3">Services</div>

        <HeaderOrange>
          Welcome to the Seller Services hub! Here, you'll find essential resources to support your success on our platform. Explore testimonials from thriving
          sellers, review important terms and policies, and access valuable training and resources. Our dedicated customer service team is here to assist you,
          and our contact and support section ensures you get the help you need promptly. Let's make your selling experience seamless and rewarding!
        </HeaderOrange>

        <Row>
          {cardData.map((item, index) => (
            <Col xs="12" sm="6" md="4" lg="3" key={index} className="mb-3">
              <Card imageSrc={item.imageSrc} label={item.label} />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  )
}

export default Services
